import VnrLink from '@components/VnrLink';
import React from 'react';
import LazyLoad from 'react-lazyload';

import styles from './BrokerWithLicense.module.scss';

const BrokersWithLicense = ({ brokerList, customerHeight }) => {
  return (
    <div className={styles.vnrBrokerList}>
      <LazyLoad>
        <div className={styles.titleSection}>
          {/* <LicenseIcon /> */}
          Broker được cấp phép ở nước ngoài
        </div>
        <div id="brokerWithLicense" className={styles.list} style={{ height: customerHeight }}>
          {brokerList.map((broker) => {
            return (
              <div key={broker.id} className={styles.item}>
                <div className={styles.itemLogo}>
                  <VnrLink aria-label={broker?.acf?.alt} to={`/forex-broker/${broker.slug}`} className="logoBrokerHaveLicense">
                    <img src={broker.thumbnail} alt={broker?.acf?.alt} />
                  </VnrLink>
                </div>
                <div className={styles.itemList}>
                  <div className={styles.brokerName}>{broker?.acf?.name}</div>
                  <div className={styles.itemAction}>
                    <VnrLink to={broker?.acf?.link_rate}>
                      <div className={styles.buttonReview}>Xem đánh giá</div>
                    </VnrLink>
                    <div
                      className={styles.buttonOpenAccount}
                      dangerouslySetInnerHTML={{
                        __html: broker?.acf?.link_register || '<a>Mở tài khoản</a>',
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </LazyLoad>
    </div>
  );
};
export default BrokersWithLicense;
